import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { AuthService } from "../services/api/auth/auth.service";

export const roleRedirectGuard: CanActivateFn = (
  _route,
  state,
): boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Only handle the bare root to avoid loops on child routes
  if (state.url === "/" || state.url === "") {
    if (authService.hasRole("MANAGER"))
      return router.parseUrl("/manager/fields-view");
    if (authService.hasRole("ENTITY"))
      return router.parseUrl("/entity/fields-view");
    if (authService.hasRole("GROWER")) return router.parseUrl("/field");
    if (authService.hasRole("ADMIN")) return router.parseUrl("/admin");
    return router.parseUrl("/login");
  }

  // Allow normal navigation for non-root URLs
  return true;
};
